import type { ConnectorPagingMetadata, IConnector } from './types';

export class Connectors {
  constructor(
    private readonly connectors: IConnector[],
    private readonly pagingMetadata: ConnectorPagingMetadata,
  ) {}

  toJSON(): IConnector[] {
    return this.connectors;
  }

  get paging(): ConnectorPagingMetadata {
    return this.pagingMetadata;
  }

  get hasNext(): boolean {
    return this.pagingMetadata.hasNext;
  }

  get nextCursor(): string | undefined {
    return this.pagingMetadata.nextCursor;
  }

  get total(): number | undefined {
    return this.pagingMetadata.total;
  }
}
